<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
  padding-bottom: 40px;
}

.billSelect {
  .el-select-dropdown__item {
    height: 68px;
  }
}
</style>
<template>
  <div class="coustomer-wrap">
    <el-dialog
      title="确认费用"
      :visible.sync="dialogVisible"
      v-loading="pageLoading"
      top="3vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      width="460px">
      <el-form
        ref="formDataRef"
        :model="formData"
        label-width="90px"
        label-position="left"
        class="clearfix"
        size="medium">
        <el-form-item prop="title" label="费用事由">
          <el-input
            v-model="formData.title"
            placeholder="请填写费用事由"></el-input>
        </el-form-item>

        <el-form-item prop="owner_company_id" label="我方公司">
          <el-select
            v-model="formData.owner_company_id"
            filterable
            placeholder="请选择公司主体"
            @change="ownerCompanyChange"
            :collapse-tags="true"
            style="width: 100%;">
            <el-option
              v-for="companyItem in companys"
              :label="companyItem.name"
              :key="companyItem.id"
              :value="companyItem.id">
              {{ companyItem.name }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="other_company_id" label="对方公司">
          <template slot="label">
            对方公司
            <az-issue :tipW="260" text="列表中如果没有所需公司，请在 企业管理 中添加供应商，如没有添加权限，请联系财务人员添加。">
            </az-issue>
          </template>
          <el-select
            v-model="formData.other_company_id"
            filterable
            placeholder="选择相关企业"
            :collapse-tags="true"
            @change="chooseOtherCompanyHandler"
            style="width: 100%;">
            <el-option
              v-for="companyItem in otherCompanys"
              :label="companyItem.name"
              :key="companyItem.id"
              :value="companyItem.id">
              {{ companyItem.name }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="purchase_bill_ids" label="关联帐单">
          <el-select
            v-model="formData.purchase_bill_ids"
            filterable
            popper-class="billSelect"
            placeholder="选择帐单"
            @change="handleBillChange"
            :multiple="true"
            :collapse-tags="true"
            style="width: 100%;">
            <el-option
              v-for="bill in relativeBills"
              :key="bill.id"
              :value="bill.id">
              <div>编号：{{ bill.id }} 币种：{{bill.currency_code}}</div>
              <div>
                月份：{{ bill.month }} 总金额：{{ bill.money }} 未付款：{{
                  bill.last_money
                }}
              </div>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="entry_pay_time	" label="入账时间">
          <el-date-picker
            style="width: 100%;"
            v-model="formData.entry_pay_time"
            format="yyyy 年 MM 月 dd 日 HH 时 mm 分 ss 秒"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="coin_type	" label="选择币种">
          <el-select
            v-model="formData.coin_type"
            placeholder="请选择币种"
            :collapse-tags="true"
            style="width: 100%;">
            <el-option
              v-for="coinItem in coins"
              :label="coinItem.name"
              :key="coinItem.id"
              :value="coinItem.id">
              {{ coinItem.name }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="sum_money	" label="税前金额">
          <el-input-number
            style="width: 100%;"
            v-model="formData.sum_money"
            :precision="2"
            :step="1"
            :min="0"
            :max="999999999"
            @blur="moneyChangeHandler(formData.sum_money, formData)">
          </el-input-number>
        </el-form-item>
        <el-form-item prop="sum_money	" label="进项税额">
          <el-input-number
            style="width: 100%;"
            v-model="formData.income_tax_money"
            :precision="2"
            :step="1"
            :min="0"
            :max="999999999"
            @blur="
              incomeMoneyChangeHandler(formData.income_tax_money, formData)
            ">
          </el-input-number>
        </el-form-item>
        <el-form-item prop="remark	" label="备注信息">
          <el-input
            v-model="formData.remark"
            type="textarea"
            placeholder="请填写备注信息">
          </el-input>
        </el-form-item>
        <el-form-item label="上传附件" class="extension">
          <template slot="label">
            上传附件
            <az-issue :tipW="200" text="仅支持jpg , jpeg, png, pdf"></az-issue>
          </template>
          <div class="invoice-wrap1">
            <el-upload
              drag
              ref="upload"
              class="avatar-uploader"
              :file-list="formData.img_keys"
              :action="`/api/base/upload?az_tk=${token}`"
              accept=".jpg,.jpeg,.png,.pdf"
              :on-remove="handleRemove"
              :on-exceed="handleExceed"
              :limit="5"
              :on-success="
                (res, file, fileList) =>
                  handleAvatarSuccess(res, file, fileList)
              "
              :before-upload="(file) => beforeAvatarUpload(file)">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button
          slot="reference"
          size="small"
          type="primary"
          :loading="btnIsLoading"
          @click="submitHandler">确认提交
        </el-button>
        <el-button
          slot="reference"
          size="small"
          @click="dialogVisible = false"
          style="margin-left: 10px;">取 消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { coins } from '@/const';
import { getCompanyList } from '@/api/company';
import azIssue from '@/base/azIssue.vue';
import {
  createApprovalInstance,
  modifyOriginalFrom,
  getRelativeBills,
} from '@/api/approval';

const formDataDefault = {
  title: '', // 事由
  owner_company_id: '', // 我方公司主体ID
  sum_money: 0, // 税前金额
  income_tax_money: 0, // 进项税额
  other_company_id: '', // 对方公司ID
  entry_pay_time: '', // 入账时间
  coin_type: '', // 币种: 1人民币, 2美元,3新币,4日元,5韩元
  remark: '',
  img_keys: [], // 附件
  purchase_bill_ids: [],
};
export default {
  name: 'confirmCost', // 确认费用
  props: {
    basicType: {
      type: String,
    },
  },
  components: {
    azIssue,
  },
  computed: {
    token() {
      return this.$store.getters.token;
    },
  },
  data() {
    return {
      pageLoading: false,
      coins,
      operationType: 'create',
      task_id: '',
      basic_type: '',
      formData: JSON.parse(JSON.stringify(formDataDefault)),
      dialogVisible: false,
      btnIsLoading: false,
      type: 'create',
      companys: [],
      otherCompanys: [],
      relativeBills: [],
    };
  },
  mounted() {
    this.$on('open', (basic_type) => {
      this.basic_type = basic_type;
      this.operationType = 'create';
      this.formData = JSON.parse(JSON.stringify(formDataDefault));
      this.initPage();
      this.dialogVisible = true;
    });
    this.$on('edit', (task_id, data) => {
      console.log(data, 'data');
      this.operationType = 'edit';
      this.task_id = task_id;
      this.dialogVisible = true;
      const {
        title, // 事由
        owner_company_id, // 我方公司主体ID
        sum_money, // 总金额
        income_tax_money, // 进项税额
        other_company_id, // 对方公司ID
        entry_pay_time, // 最晚付款日期
        coin_type, // 币种: 1人民币, 2美元,3新币,4日元,5韩元
        remark,
        img_keys, // 附件
        purchase_bill_ids,
      } = data;

      this.formData = {
        title, // 事由
        owner_company_id, // 我方公司主体ID
        sum_money, // 总金额
        income_tax_money, // 进项税额
        other_company_id, // 对方公司ID
        entry_pay_time, // 最晚付款日期
        coin_type, // 币种: 1人民币, 2美元,3新币,4日元,5韩元
        remark,
        img_keys, // 附件
        purchase_bill_ids,
      };
      this.initPage();
    });
  },
  methods: {
    dealCoinType(bill_coin_type, form_coin_type, val) {
      if (!form_coin_type) {
        this.formData.coin_type = bill_coin_type;
        return;
      }
      if (val.length == 1) {
        this.formData.coin_type = bill_coin_type;
        console.log(this.formData.coin_type, 'coin_type')
        return
      }
      if (bill_coin_type != form_coin_type) {
        this.$message.warning('选择帐单中包含不同币种，或帐单币种和选择币种不同，请注意核对');
        return
      }
    },
    handleBillChange(val) {
      console.log(val, 'val');
      let billMoney = 0;
      for (let i = 0; i < val.length; i++) {
        for (let k = 0; k < this.relativeBills.length; k++) {
          if (this.relativeBills[k].id == val[i]) {
            billMoney += this.relativeBills[k].money * 100;
            this.dealCoinType(this.relativeBills[k].currency_id, this.formData.coin_type, val)

            continue;
          }
        }
      }
      // this.formData.sum_money = billMoney / 100;
      billMoney = billMoney / 100;
      console.log(billMoney);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.formData.img_keys = fileList;
    },
    handleExceed(files, fileList) {
      this.$message({
        message: '同时最多只能上传5个文件',
        type: 'error',
      });
    },
    handleAvatarSuccess(res, file, fileList) {
      if (res.code != 0 || !res.data) {
        this.$message.error('上传失败');
        // this.formData.detail[index].uploadLoading = true
      } else {
        // this.formData.img_keys = fileList;
        this.formData.img_keys.push({ name: file.name, key: res.data.key });
        this.$message({
          message: '上传成功',
          type: 'success',
        });
      }
    },
    beforeAvatarUpload(file) {
      console.log(file);
      console.log(this.fileList, 'fileList');
      let isImg = true;
      if (file.name) {
        const names = file.name.split('.');
        isImg = ['png', 'jpg', 'jpeg', 'pdf'].includes(names[names.length - 1]);
      }
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isImg) {
        this.$message.error('请上传png, jpg, jpeg, pdf类型的文件');
        return false;
      }
      // 判断上传文件格式是否正确
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 20MB!');
        return false;
      }
      return true;
    },
    moneyChangeHandler(moeny, item) {
      if (typeof moeny !== 'number') {
        item.sum_money = 0;
      }
    },
    incomeMoneyChangeHandler(moeny, item) {
      if (typeof moeny !== 'number') {
        item.income_tax_money = 0;
      }
    },
    ownerCompanyChange(owner_company_id) {
      this.formData.purchase_bill_ids = [];
      this.relativeBills = [];
      this.otherCompanys = [];
      this.formData.other_company_id = '';
      getCompanyList({
        status: 2,
        page: 1,
        per_page: 10000,
        type: 2,
        owner_company: owner_company_id,
      })
        .then((res) => {
          if (res.code != 0) throw new Error(res.message);
          this.otherCompanys = res.data.items;
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    chooseOtherCompanyHandler(company_id) {
      // 获取帐单列表
      this.formData.purchase_bill_ids = [];
      this.relativeBills = [];
      getRelativeBills(this.basic_type, company_id)
        .then((res) => {
          if (res.code != 0) throw new Error(res.message);
          this.relativeBills = res.data;
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    async initPage() {
      // 创建和编辑初始化共用的
      this.pageLoading = true;
      let companyRes = await getCompanyList({
        status: 2,
        page: 1,
        per_page: 1000,
        type: 1,
      });
      if (
        companyRes.code === 0 &&
        companyRes.data &&
        Array.isArray(companyRes.data.items)
      ) this.companys = companyRes.data.items;

      if (this.operationType == 'edit') {
        // 编辑额外需要初始化的
        // 根据我方公司id获取对方公司列表
        let otherCompanyRes = await getCompanyList({
          status: 2,
          page: 1,
          per_page: 1000,
          type: 2,
          owner_company: this.formData.owner_company_id,
        });
        if (
          otherCompanyRes.code === 0 &&
          otherCompanyRes.data &&
          Array.isArray(otherCompanyRes.data.items)
        ) this.otherCompanys = otherCompanyRes.data.items;
        const billRes = await getRelativeBills(
          this.basic_type,
          this.formData.other_company_id
        );
        if (billRes.code === 0 && billRes.data) this.relativeBills = billRes.data;
      }
      this.pageLoading = false;
    },
    createApprovalInstanceHandler() {
      this.btnIsLoading = true;
      createApprovalInstance(this.basic_type, this.formData)
        .then((res) => {
          console.log('res', res);
          if (res.code != 0) throw new Error(res.message);
          this.$message.success('保存成功');
          this.dialogVisible = false;
          this.$emit('refresh');
        })
        .catch((err) => {
          this.$message.error(err.message);
        })
        .finally(() => {
          this.btnIsLoading = false;
        });
    },
    editApprovalInstanceHandler() {
      this.btnIsLoading = true;
      modifyOriginalFrom(this.task_id, this.formData)
        .then((res) => {
          console.log('res', res);
          if (res.code != 0) throw new Error(res.message);
          this.$message.success('保存成功');
          this.dialogVisible = false;
          this.$emit('refresh');
        })
        .catch((err) => {
          this.$message.error(err.message);
        })
        .finally(() => {
          this.btnIsLoading = false;
        });
    },
    submitHandler() {
      this.formData.img_keys = this.formData.img_keys.map((item) => {
        return { name: item.name, key: item.key };
      });
      this[`${this.operationType}ApprovalInstanceHandler`]();
    },
  },
};
</script>